import React, { useState, useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import Header from './components/Header'
import Home from './pages/Home'
import SearchResults from './pages/SearchResults'
import PropertyDetail from './pages/PropertyDetail'
import Login from './pages/Login'
import HostDashboard from './pages/HostDashboard'
import { Property } from './types'

const API_BASE_URL = 'https://xeniosdeals-backend.netplayer.workers.dev/api'

function App() {
  const [searchParams, setSearchParams] = useState({
    city: '',
    check_in: '',
    check_out: '',
    guests: 1
  })
  const [user, setUser] = useState<any>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    // Check if user is logged in
    const token = localStorage.getItem('auth_token')
    const savedUser = localStorage.getItem('user')
    
    if (token && savedUser) {
      setUser(JSON.parse(savedUser))
    }
    
    // Force loading to complete after a short delay to prevent any stuck states
    const timer = setTimeout(() => {
      setLoading(false)
    }, 100)
    
    return () => clearTimeout(timer)
  }, [])

  const handleLogin = (userData: any) => {
    setUser(userData)
  }

  const handleLogout = () => {
    setUser(null)
    // Call logout API
    fetch(`${API_BASE_URL}/auth/logout`, { method: 'POST' })
  }

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    )
  }

  return (
    <Router>
      <div className="min-h-screen bg-white">
        {/* Show Header for all pages except dashboard pages */}
        <Routes>
          <Route path="/host/dashboard" element={null} />
          <Route path="/admin/dashboard" element={null} />
          <Route path="*" element={
            <Header 
              searchParams={searchParams} 
              setSearchParams={setSearchParams} 
              user={user}
              onLogout={handleLogout}
            />
          } />
        </Routes>
        
        <main className="bg-white">
          <Routes>
            <Route path="/" element={<Home searchParams={searchParams} setSearchParams={setSearchParams} />} />
            <Route path="/search" element={<SearchResults searchParams={searchParams} />} />
            <Route path="/properties/:id" element={<PropertyDetail />} />
            <Route path="/login" element={
              user ? <Navigate to="/" replace /> : <Login onLogin={handleLogin} />
            } />
            <Route path="/host/dashboard" element={
              user?.role === 'HOST' ? (
                <HostDashboard user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" replace />
              )
            } />
            {/* Redirect to home for unknown routes */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
      </div>
    </Router>
  )
}

export default App
